import { ICall } from '@/types';
import { getUrl } from '@/utils/api';

function useCalls(filter?: string) {
  let url = `v1/calls`;
  if (filter) {
    url += `?call_type=${filter}`;
  }
  const query = getUrl(url);

  const transformedData = query.data ? (Array.isArray(query.data) ? query.data : []) : [];

  return {
    ...query,
    data: transformedData as ICall[],
  };
}

export default useCalls;
